import { ReactNode } from 'react';

interface ImageRowProps {
  children: ReactNode;
  gap?: 'sm' | 'md' | 'lg';
  align?: 'start' | 'center' | 'end';
}

export function ImageRow({
  children,
  gap = 'md',
  align = 'center'
}: ImageRowProps) {
  const gapClasses = {
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
  };

  const alignClasses = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
  };

  return (
    <div className={`flex flex-col sm:flex-row ${gapClasses[gap]} ${alignClasses[align]}`}>
      {children}
    </div>
  );
}
